import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";
import { useTheme } from "@mui/material/styles";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const filterExhibitions = () => {
  const filterString = ($("#search-input").val() ? $("#search-input").val() : '') + ($("#search-input-mobile").val() ? $("#search-input-mobile").val() : '');
  $("div[data-type=\"exhibitionListItem\"]").each((index, el) => {
    if (
      !($("#ex-title", el)[0].innerText.match(new RegExp(filterString, "i"))) &&
      !($("#ex-subtitle", el)[0].innerText.match(new RegExp(filterString, "i")))
    ) {
      $(el).hide();
    } else {
      const locations = $(el).attr("data-locations");
      if (locations?.match(new RegExp(APP.arrangement.selectedLocation, "i")) || APP.arrangement.selectedLocation === "All") {
        $(el).show();
      }
    }
  });

  if (filterString && filterString.length > 0) {
    $(".search-clear").show();
    $("#search-start").hide();
    $("#locations").hide();
    $("#venues-head").hide();
    $("#exhibitions-head").hide();
    $("#search-head").show();
    if (window.innerWidth < 1200) {
      $("#slider-main").hide();
    }
  } else {
    $(".search-clear").hide();
    $("#search-start").show();
    $("#locations").show();
    $("#venues-head").show();
    $("#exhibitions-head").show();
    $("#search-head").hide();
    if (window.innerWidth < 1200) {
      $("#slider-main").show();
    }
  }

  if ($('div[data-type="exhibitionListItem"]:visible').length === 0) {
    $("#no-results").show();
  } else {
    $("#no-results").hide();
  }
};

const toggleMobileSearch = () => {
  $("#search-toggle").toggle();
  $("#search-box").toggle();
  setTimeout(() => {
    $("search-input-mobile").focus();
  }, 300);
  clearSearch();
};

const clearSearch = () => {
  $("#search-input").val("");
  $("#search-input-mobile").val("");
  filterExhibitions();
};

export function SearchInput() {
  const theme = useTheme();
  return (
    <Box sx={{
      visibility: "hidden",
      [theme.breakpoints.up("lg")]: {
        visibility: "visible",
      },
    }}>
      <Box
        sx={{
          p: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "44px",
          position: "relative",
          [theme.breakpoints.up("lg")]: {
            width: "200px",
            marginBottom: 0,
            marginRight: '24px',
          },
        }}
      >
        <InputBase
          sx={{
            height: "100%",
            width: "100%",
            minWidth: "180px",
            borderRadius: "62px 0 0 62px",
            background: "#F5F6FA",
            position: "relative",
            [theme.breakpoints.up("lg")]: {
              right: "-15px",
            },
            ".MuiInputBase-input": {
              padding: "11px 20px",
            },
          }}
          placeholder={I18N("Search")}
          inputProps={{ "aria-label": "search", "id": "search-input" }}
          onChange={filterExhibitions}
        />
        <IconButton
          className={"search-clear"}
          sx={{
            p: "3px",
            borderRadius: "50%",
            position: "absolute",
            top: "8px",
            bottom: 0,
            right: "27px",
            height: "10px",
            display: "none",
          }}
          color="grey"
          onClick={clearSearch}
        >
          <CancelIcon />
        </IconButton>
        <IconButton
          sx={{
            p: "10px",
            borderRadius: "34px",
            backgroundColor: "#C91113",
            "&:hover": {
              backgroundColor: "#c91113cc",
              color: "#fff",
            },
          }}
          color="white"
          onClick={filterExhibitions}
        >
          <SearchIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

export function SearchButton() {
  const theme = useTheme();
  return (
    <>
      <Box sx={{
        display: "block",
        [theme.breakpoints.up("lg")]: {
          display: "none",
        },
      }}>
        <IconButton
          id={"search-toggle"}
          sx={{
            borderRadius: "50%",
          }}
          color="grey"
          variant="contained"
          onClick={toggleMobileSearch}
        >
          <SearchIcon />
        </IconButton>
      </Box>
      <Box
        id={"search-box"}
        sx={{
          display: "none",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          zIndex: 9000,
          [theme.breakpoints.up("lg")]: {
            display: "none",
          },
        }}
      >
        <Box
          sx={{
            p: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            height: "100%",
            position: 'relative',
          }}
        >
          <ChevronLeftIcon
            sx={{
              marginRight: "12px",
            }}
            onClick={toggleMobileSearch}
          />
          <InputBase
            sx={{
              height: "44px",
              width: "100%",
              borderRadius: "21px",
              background: "#F5F6FA",
              position: "relative",
              ".MuiInputBase-input": {
                padding: "11px 20px",
              },
            }}
            placeholder={I18N("Search")}
            inputProps={{ "aria-label": "search", "id": "search-input-mobile", 'autoFocus': true }}
            onChange={filterExhibitions}
          />
          <IconButton
            className={"search-clear"}
            sx={{
              p: "3px",
              height: '100%',
              borderRadius: "50%",
              position: "absolute",
              top: "3px",
              bottom: 0,
              right: "10px",
              display: "none",
            }}
            color="grey"
            onClick={clearSearch}
          >
            <CancelIcon />
          </IconButton>
          <IconButton
            id={"search-start"}
            sx={{
              p: "3px",
              position: "absolute",
              top: "24px",
              bottom: 0,
              right: "10px",
              height: "10px",
              backgroundColor: "transparent",
              '&:hover': {
                backgroundColor: 'transparent',
              },
              '&:focus': {
                backgroundColor: 'transparent',
              },
              '&:active': {
                backgroundColor: 'transparent',
              }
            }}
            variant="text"
            onClick={filterExhibitions}
          >
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
